import { PaperClipOutlined, DeleteOutlined } from '@ant-design/icons';
import { EAttachmentType } from '@constants';
import { IAttachment } from '@sdk/contracts';
import { Input, Tooltip, App } from 'antd';
import { ChangeEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Item, Wrapper } from './LinkAttachment.styles';

import { Icon } from '@/components/Icon';
import { isValidUrl } from '@/utils';

type Props = {
  links: string[];
  onAdd: (value: IAttachment) => void;
  onRemove: (link: string) => void;
};

export const LinkAttachment: React.FC<Props> = ({ links, onAdd, onRemove }) => {
  const { message } = App.useApp();
  const { t } = useTranslation('CourseTranslations');

  const [value, setValue] = useState<string | undefined>();

  const handleSetValue = (e: ChangeEvent<HTMLInputElement>) => setValue(e.target.value);

  const handleAddLink = () => {
    const isValid = isValidUrl(value);

    if (!isValid) {
      message.error(t('PLEASE_ENTER_VALID_URL'));
      return;
    }

    if (value && isValid) {
      onAdd({ type: EAttachmentType.LINK, link: value });
      setValue(undefined);
    }
  };

  const handleRemoveLink = (link: string) => onRemove(link);

  return (
    <Wrapper>
      <Input
        type="url"
        value={value}
        onChange={handleSetValue}
        placeholder={t('ATTACH_LINKS_PLACEHOLDER')}
        onPressEnter={handleAddLink}
        addonAfter={<Icon i="Link" />}
      />

      {links.map((link, index) => (
        <Item key={link}>
          <PaperClipOutlined />
          <Tooltip title={link}>
            <a href={link} target="_blank" rel="noreferrer">
              {t('EXTERNAL_RESOURCE_LINK', { count: index + 1 })}
            </a>
          </Tooltip>
          <DeleteOutlined onClick={() => handleRemoveLink(link)} />
        </Item>
      ))}
    </Wrapper>
  );
};
